import React from 'react';
import '../../css/JuanIS/JuanISOnlineTeacherEvaluation.css';
import { FaChalkboardTeacher } from 'react-icons/fa';

function JuanISOnlineTeacherEvaluation() {
  // Sample professors data
  const professors = [
    {
      name: 'Ms. Marlyn Mabatid',
      subject: 'Math Part 1',
      section: 'MS1234',
      status: 'pending' // pending or done
    },
    {
      name: 'Ms. Marlyn Mabatid',
      subject: 'Math Part 1',
      section: 'MS1234',
      status: 'pending'
    },
    {
      name: 'Ms. Marlyn Mabatid',
      subject: 'Math Part 1',
      section: 'MS1234',
      status: 'pending'
    },
    {
      name: 'Mr. Jerry Cruz',
      subject: 'Physical Education',
      section: 'MS1234',
      status: 'done'
    },
    {
      name: 'Mr. Jerry Cruz',
      subject: 'Physical Education',
      section: 'MS1234',
      status: 'done'
    },
    {
      name: 'Mr. Jerry Cruz',
      subject: 'Physical Education',
      section: 'MS1234',
      status: 'done'
    }
  ];

  return (
    <div className="juanis-ote-container">
      <div className="juanis-ote-header">
        <h1>Online Teacher's Evaluation (OTE)</h1>
      </div>

      <div className="juanis-ote-subtitle">
        <p>Grade your professors and send your feedback to share your opinions about their teaching!</p>
      </div>

      <div className="juanis-ote-professors-grid">
        {professors.map((professor, index) => (
          <div key={index} className="juanis-ote-professor-card">
            <div className="juanis-ote-professor-avatar">
              <div className={`juanis-ote-avatar-container ${professor.name.includes('Ms.') ? 'female' : 'male'}`}>
                <FaChalkboardTeacher className="juanis-ote-avatar-icon" />
              </div>
            </div>
            <div className="juanis-ote-professor-info">
              <h3>{professor.name}</h3>
              <p>Subject: {professor.subject}</p>
              <p>Section: {professor.section}</p>
            </div>
            <button 
              className={`juanis-ote-evaluate-button ${professor.status === 'done' ? 'done' : 'pending'}`}
            >
              {professor.status === 'done' ? 'Done' : 'Evaluate'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default JuanISOnlineTeacherEvaluation;